import { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { DataContext } from 'providers/data'
import { DecodeToken } from 'utils/decodeToken';
import { SalesChannelEnum, ProfileVersionEnum } from 'utils/enums';
import { LoadConfig } from 'utils/loadConfig';
import { collection, query, getDocs } from "firebase/firestore";
import { ParsePerfilQuotation, ParseProfileVersion } from 'utils/parsePerfilQuotationAddServices';
import { ParamsProductServiceAdd, ParamsProducAddTemplate, ParamsPageWebView } from 'utils/typeServices';

import { DbGet } from 'config/firebase';

import PageErrors from 'components/views/PageErrors';
import ParseWebView from 'components/views/ParseWebView';
import Faq from 'components/views/AdditionalServices/Faq';
import FadeAnimation from 'components/views/FadeAnimation';
import { Box, Typography, Skeleton } from '@mui/material';

import Modals from 'components/views/Modals';
import Select from 'components/views/form/Select';
import FormVehicle from 'components/views/FormVehicle';
import ShoppingCart from 'components/views/AdditionalServices/ShoppingCart';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';
import SkeletonLoading from 'components/views/AdditionalServices/SkeletonLoading';
import PackagesServices from 'components/views/AdditionalServices/PackagesServices';
import IndividualServices from 'components/views/AdditionalServices/IndividualServices';


import { Step, StepLabel, Stepper, ContentShopping } from './styles';

const steps: Array<string> = [
    'Serviços adicionais',
    'Pagamento',
    'Conclusão'
];

type ParamsArray = {
    text: string;
    value: string;
}

const ServicesList = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState(false);
    const [showPageError, setShowPageError] = useState(false);
    const [showModalIsFormCar, setShowModalIsFormCar] = useState(false);
    const [versionsCarSelected, setVersionsCarSelected] = useState<ParamsArray>();
    const [listVersionsCar, setListVersionsCar] = useState<Array<ParamsArray>>([]);
    const [modelSelectedCar, setModelSelectedCar] = useState<{
        NR_ANO: number;
        CD_MODELO: number;
        NR_ANO_FABRICACAO: number;
        DS_CHASSI: string;
    }>();
    const [listPackagesServices, setListPackagesServices] = useState<Array<ParamsProductServiceAdd>>([]);
    const [listIndividualServices, setListIndividualServices] = useState<Array<ParamsProductServiceAdd>>([]);
    const [listServicesAddTemplate, setListServicesAddTemplate] = useState<Array<ParamsProducAddTemplate>>([]);

    const { dataPerfilUser, selectedCar, dataListQuoteAdd, dataProductCartAddServices, dataChooseQuoteItemsAddServices, dataGetListarCotacoesAddService, customerCars, isFormCarAddService, dataCar, dataCustomerForEdit, handlePostChooseQuoteItemsAddServices, handleParseProductCartAddServices, handleSelectedCar, handlePostCreateQuote, handleSearchCar } = useContext(DataContext);

    const getServicesAddTemplate = async () => {
        let data: { servicos: Array<ParamsProducAddTemplate> } = { servicos: [] };

        const coverages = query(collection(DbGet, "servicos_adicionais"));
        const querySnapshot = await getDocs(coverages);

        querySnapshot.forEach((doc) => {
            // @ts-ignore
            data = doc.data();
        });

        if (Array.isArray(data?.servicos)) {
            setListServicesAddTemplate(data?.servicos);
        }
    }

    const handlePostCreateQuoteState = () => {
        const tokenDetailsAux = DecodeToken();

        if (selectedCar && modelSelectedCar && dataCustomerForEdit) {
            handlePostCreateQuote({
                bodyLead: {
                    DS_EMAIL: selectedCar.EMAIL,
                    NM_LEAD: selectedCar.NOME_CLIENTE,
                    NR_TELEFONE: (tokenDetailsAux?.cellphone || '').replace(/[^0-9]/g, ''),
                    NM_URL_CRIACAO: window.location.host,
                    CD_PESSOA_PARCEIRO_CRIACAO: selectedCar.CD_PESSOA_PARCEIRO || 1783625,
                    CD_CANAL_VENDA_CRIACAO: SalesChannelEnum.TrocasAreaCliente,
                    JS_CONSENTIMENTO: {
                        optin: {
                            messaging: true,
                            voice: true,
                            email: false,
                            'social-media': false,
                        },
                    },
                },
                bodyQuote: {
                    DS_CHASSI: modelSelectedCar.DS_CHASSI,
                    DS_INSTALACAO: null,
                    NR_ANO: modelSelectedCar.NR_ANO,
                    NR_ANO_FABRICACAO: modelSelectedCar.NR_ANO_FABRICACAO,
                    CD_TIPO_COMERCIALIZACAO: 2,
                    DS_PERFIL: dataPerfilUser ? ParsePerfilQuotation(dataPerfilUser) : null,
                    SISTEMA_ENUM: 16,
                    NR_TIPO_COTACAO: 7,
                    NR_CPF_CNPJ: selectedCar.NR_CNPJ_CPF,
                    DS_PLACA: selectedCar.PLACA,
                    NR_CEP_PERNOITE: `${dataPerfilUser ? dataPerfilUser?.CEP_PERNOITE : dataCustomerForEdit?.addressList[0].zipcode}`.replace(/[^0-9]/g, ''),
                    CD_LEAD: "",
                    CD_PESSOA_VENDEDOR: `${selectedCar.CD_PESSOA_VENDEDOR}`,
                    CD_PESSOA_RESPONSAVEL: `${selectedCar.CD_PESSOA}`,
                    CD_PESSOA_PARCEIRO: selectedCar.CD_PESSOA_PARCEIRO || 1783625,
                    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: selectedCar.CD_PESSOA_PARCEIRO_ESTABELECIMENTO || 1783625,
                    CD_CANAL_VENDA: SalesChannelEnum.TrocasAreaCliente,
                    CD_CANAL_VENDA_PARCEIRO: null,
                    CD_MODELO: modelSelectedCar.CD_MODELO,
                    CD_PESSOA_ORIGEM: selectedCar.CD_PESSOA,
                    NR_PLATAFORMA_ORIGEM: selectedCar.NR_PLATAFORMA,
                    DS_COR: selectedCar.COR || '',
                    DT_NASCIMENTO: dataCustomerForEdit.birthDate,
                    NR_VERSAO_PERFIL: dataPerfilUser ? ParseProfileVersion(dataPerfilUser) : ProfileVersionEnum.OldVersion
                },
                nrPlatform: selectedCar.NR_PLATAFORMA
            })
        }
    }

    const handleParseProductCartAddServicesState = () => {
        if (dataGetListarCotacoesAddService?.quoteItemsChooses && selectedCar) {
            handleParseProductCartAddServices({
                body: {
                    cD_COTACAO: dataGetListarCotacoesAddService.quote.cD_COTACAO,
                    cD_PEDIDO: state.cD_PEDIDO,
                    customerId: selectedCar.CD_PESSOA,
                    quoteItemsChooses: dataGetListarCotacoesAddService?.quoteItemsChooses
                }
            });
        }
    }

    const handlePostChooseQuoteItemsAddServicesState = () => {
        setIsLoadingBtn(true);
        if (dataListQuoteAdd) {
            handlePostChooseQuoteItemsAddServices({
                CD_COTACAO: dataListQuoteAdd.CD_COTACAO,
                CD_CANAL_VENDA: dataListQuoteAdd.CD_CANAL_VENDA,
                CD_PESSOA_PARCEIRO: dataListQuoteAdd.CD_PESSOA_PARCEIRO,
                CD_PESSOA_VENDEDOR: dataListQuoteAdd.CD_PESSOA_VENDEDOR,
                CD_PESSOA_PARCEIRO_ESTABELECIMENTO: dataListQuoteAdd.CD_PESSOA_PARCEIRO_ESTABELECIMENTO
            },
                isWebView
            );
        }
    }

    const handleSelectedCarAddService = (e: ParamsArray) => {
        if (Array.isArray(isFormCarAddService)) {
            const modelSelected = isFormCarAddService?.find(({ NM_VERSAO }) => NM_VERSAO === e?.text);

            if (modelSelected) {
                setModelSelectedCar({
                    CD_MODELO: modelSelected.CD_MODELO,
                    DS_CHASSI: modelSelected.DS_CHASSI,
                    NR_ANO: modelSelected.NR_ANO,
                    NR_ANO_FABRICACAO: modelSelected.NR_ANO_FABRICACAO
                });
            }
        }
    }

    const handleSetDataFormVehicle = (e: { year: string; version: number; chassis: string; yearManufacture: string; }) => {
        setModelSelectedCar({
            CD_MODELO: e.version,
            DS_CHASSI: e.chassis,
            NR_ANO: parseInt(e.year),
            NR_ANO_FABRICACAO: parseInt(e.yearManufacture)
        });
    }

    const filterNonEligiblePlatinumProducts = (items: Array<ParamsProductServiceAdd>) => {
        const PLATINUM_PRODUCTS = LoadConfig().REACT_APP_PLATINUM_PRODUCTS;

        return items
            .filter(({ VL_TOTAL }) => parseFloat(VL_TOTAL.split(' ')[1].replace(',', '.')) > 0)
            .filter(({ CD_PRODUTO }) => !PLATINUM_PRODUCTS.includes(CD_PRODUTO));
    }

    useEffect(() => {
        if (dataListQuoteAdd) {
            setListPackagesServices([]);
            setListIndividualServices([]);

            const cotacaoItems = filterNonEligiblePlatinumProducts(dataListQuoteAdd.COTACAO_ITEMS);

            let auxListPackagesServices = cotacaoItems.filter(({ NR_TIPO_PRODUTO, NM_PRODUTO, VL_TOTAL }) => NR_TIPO_PRODUTO === 13 && NM_PRODUTO?.includes("Pacote") && (parseFloat(VL_TOTAL.split(' ')[1].replace(',', '.')) !== 0));
            let auxListIndividualServices = cotacaoItems.filter(({ NR_TIPO_PRODUTO, NM_PRODUTO, CD_PRODUTO, VL_TOTAL }) => NR_TIPO_PRODUTO === 13 && !NM_PRODUTO?.includes("Pacote") && CD_PRODUTO !== 1812 && (parseFloat(VL_TOTAL.split(' ')[1].replace(',', '.')) !== 0));

            const sortListPackagesServices = auxListPackagesServices?.sort((a, b) => parseFloat(a.VL_TOTAL?.split(' ')[1]?.replace(',', '.')) - parseFloat(b.VL_TOTAL?.split(' ')[1]?.replace(',', '.')));
            const sortListIndividualServices = auxListIndividualServices?.sort((a, b) => parseFloat(a.VL_TOTAL?.split(' ')[1]?.replace(',', '.')) - parseFloat(b.VL_TOTAL?.split(' ')[1]?.replace(',', '.')));

            setListPackagesServices(sortListPackagesServices);
            setListIndividualServices(sortListIndividualServices);
        }
    }, [dataListQuoteAdd]);

    useEffect(() => {
        if (typeof dataChooseQuoteItemsAddServices !== "undefined") {
            setIsLoadingBtn(false);
        }
    }, [dataChooseQuoteItemsAddServices]);

    useEffect(() => {
        if (state?.isExchangesInProgress) {
            handleParseProductCartAddServicesState();

            const carSelected = customerCars.find(({ CD_PEDIDO }) => CD_PEDIDO === state.cD_PEDIDO);

            if (carSelected) {
                handleSelectedCar(carSelected);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        if (selectedCar) {
            getServicesAddTemplate();
        }
    }, [selectedCar]);

    useEffect(() => {
        if (dataListQuoteAdd === false) {
            if (typeof isFormCarAddService === 'undefined') {
                setShowPageError(true);
            } else if (Array.isArray(isFormCarAddService)) {
                setListVersionsCar(isFormCarAddService?.map(({ NM_VERSAO }, index) => ({ text: NM_VERSAO, value: `${index}` })));
                setShowModalIsFormCar(true);
            } else if (isFormCarAddService === true) {
                handleSearchCar({ typeDetailsCar: 'brands', codDetailCar: 0 });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataListQuoteAdd, isFormCarAddService]);

    useEffect(() => {
        if (typeof dataCar !== 'undefined') {
            setShowModalIsFormCar(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCar]);

    return (
        <ParseWebView isWebView={isWebView} typePage='page'>
            {showPageError &&
                <Box sx={{ width: '100%', display: 'flex', height: { xs: 'calc(100vh - 16.875rem)', md: 'calc(100vh - 4rem)' }, alignItems: 'center', justifyContent: 'center' }}>
                    <PageErrors isWebView={false} link={`${isWebView ? '/wb' : ''}/servicos-adicionais`} />
                </Box>
            }

            {!showPageError &&
                <>
                    <Box sx={{ padding: { xs: isWebView ? '0 0 4.06rem' : '0', md: '1rem 2rem 2rem 0' }, borderTop: { xs: 'none', md: '1px solid rgba(141, 155, 181, 0.5)' }, width: { xs: '100%', md: '70%' } }}>
                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            margin: { xs: '.5rem 0 1rem', md: '.54rem 0 1.4rem' },
                            paddingBottom: '.75rem',
                            justifyContent: 'center'
                        }}>
                            <Stepper activeStep={0} alternativeLabel>
                                {steps.map((label, index) => (
                                    <Step key={index}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                        {dataListQuoteAdd ?
                            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: '0', md: '1.4rem' }, alignItems: { xs: 'flex-start', md: 'flex-end' }, justifyContent: 'center', backgroundColor: 'primary.light', padding: '.6rem 1.2rem .5rem', marginBottom: '1.49rem' }}>
                                <Box sx={{ display: 'flex', alignItems: { xs: 'flex-start', md: 'flex-end' }, flexDirection: { xs: 'column', md: 'row' } }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: '.7rem', marginRight: '.5rem', paddingBottom: { xs: '.3rem', md: '0' } }}>
                                        Veículo:
                                    </Typography>
                                    <Typography variant='subtitle2'>
                                        <strong>Placa: </strong>
                                        {dataListQuoteAdd && dataListQuoteAdd.DS_PLACA}
                                    </Typography>
                                </Box>
                                <Box sx={{ width: '1px', height: '1rem', backgroundColor: 'white', display: { xs: 'none', md: 'flex' } }} />
                                <Typography variant='subtitle2'>
                                    <strong>Modelo: </strong>
                                    {dataListQuoteAdd && dataListQuoteAdd.NM_MODELO}
                                </Typography>
                            </Box>
                            :
                            <Skeleton animation="wave" variant="rounded" height='2.1rem' sx={{ marginBottom: '1.49rem' }} />
                        }

                        <FadeAnimation>
                            <Box>
                                {dataListQuoteAdd ?
                                    <>
                                        {listIndividualServices.length > 0 &&
                                            <IndividualServices ListServices={listIndividualServices} cdQuotation={dataListQuoteAdd.CD_COTACAO} listServicesAddTemplate={listServicesAddTemplate} />
                                        }
                                        {listPackagesServices.length > 0 &&
                                            <PackagesServices ListPackagesServices={listPackagesServices} cdQuotation={dataListQuoteAdd.CD_COTACAO} listServicesAddTemplate={listServicesAddTemplate} />
                                        }
                                    </>
                                    :
                                    <SkeletonLoading />
                                }
                                <Faq />
                                <Box sx={{ display: { xs: 'block', md: 'none' }, marginTop: '.75rem', 'button': { width: '100%', marginTop: '.5rem' } }}>
                                    <ButtonRectangle
                                        name='CONTINUAR'
                                        disabled={dataProductCartAddServices?.productAdd?.length === 0}
                                        loadingBtn={isLoadingBtn}
                                        onClick={() => handlePostChooseQuoteItemsAddServicesState()} />

                                    <ButtonOutlined
                                        name='CANCELAR'
                                        onClick={() => setIsOpenModal(true)} />
                                </Box>
                            </Box>
                        </FadeAnimation>
                    </Box>

                    <ContentShopping>
                        {dataListQuoteAdd ?
                            <ShoppingCart isWebView={isWebView} />
                            :
                            <Box sx={{
                                width: '100%',
                                maxHeight: '100%',
                                backgroundColor: '#EFF2F5'
                            }}>
                                <Skeleton animation="wave" variant="rounded" height='25rem' sx={{ top: '23%', borderRadius: '10px' }} />
                            </Box>
                        }
                    </ContentShopping>

                    <Modals open={showModalIsFormCar}>
                        <Box sx={{ textAlign: 'center', borderRadius: '8px', padding: '2rem', width: { xs: 'calc(100vw - 2rem)', md: '26rem' } }}>
                            {isFormCarAddService === true ?
                                <FormVehicle handleReturnFormData={(e) => handleSetDataFormVehicle(e)} />
                                :
                                <Box>
                                    <Box sx={{
                                        width: '100%',
                                        height: '2.5rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        borderRadius: '40px',
                                        justifyContent: 'center',
                                        backgroundColor: 'primary.light',
                                    }}>
                                        <Typography fontWeight={700} color='white' fontSize='1.5rem'>
                                            IMPORTANTE
                                        </Typography>
                                    </Box>

                                    <Typography fontWeight={400} padding='1.5rem 0 .5rem' textAlign='center' fontSize='1.125rem' maxWidth='18rem' margin='0 auto'>
                                        Para continuarmos <strong>selecione</strong> a versão do seu veículo!
                                    </Typography>

                                    <Select
                                        label='Versão'
                                        placeholder='Selecione'
                                        itemSelected={versionsCarSelected}
                                        listItems={listVersionsCar}
                                        onChangeSelected={(e) => { handleSelectedCarAddService(e); setVersionsCarSelected(e); }}
                                    />
                                </Box>
                            }

                            <Box sx={{ 'button': { width: '100%' }, marginTop: '2rem' }}>
                                <ButtonRectangle
                                    name="CONTINUAR"
                                    disabled={isFormCarAddService === true ?
                                        (modelSelectedCar ? false : true)
                                        :
                                        (versionsCarSelected ? false : true)
                                    }
                                    onClick={() => { setShowModalIsFormCar(false); handlePostCreateQuoteState(); }} />
                            </Box>
                        </Box>
                    </Modals>

                    <Modals open={isOpenModal}>
                        <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '25.6rem' } }}>
                            <Box sx={{ padding: { xs: '1.78rem .9rem .59rem', md: '1.78rem 1.71rem 1.59rem' } }}>
                                <Typography fontSize='1.25rem' paddingBottom='1rem' fontWeight='700'>
                                    Poxa, que pena que desistiu!
                                </Typography>
                                <Typography fontSize='1rem' lineHeight='1.27'>
                                    Não se preocupe, o seu pedido <b>está guardado</b>, volte quando quiser e continue de onde parou.
                                </Typography>
                            </Box>
                            <Box sx={{ borderRadius: '0 0 8px 8px', backgroundColor: 'primary.main', padding: { xs: '2.17rem 2.6rem 2.5rem', md: '2.17rem 4.21rem 2.57rem' }, 'button': { width: '100%' } }}>
                                <ButtonRectangle
                                    name='FECHAR'
                                    onClick={() => navigate(`${isWebView ? '/wb' : ''}/servicos-adicionais`)} />
                            </Box>
                        </Box>
                    </Modals>
                </>
            }
        </ParseWebView>
    );
}

export default ServicesList;